var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].href.includes('product')) {
    links[i].target = '_blank';
  }
}

if ("undefined" == typeof jQuery)
  throw new Error("Bootstrap's JavaScript requires jQuery");
+(function (t) {
  "use strict";
  var e = t.fn.jquery.split(" ")[0].split(".");
  if (
    (e[0] < 2 && e[1] < 9) ||
    (1 == e[0] && 9 == e[1] && e[2] < 1) ||
    e[0] > 3
  )
    throw new Error(
      "Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4"
    );
})(jQuery),
  +(function (t) {
    "use strict";
    function e(e, i) {
      var o = e.nodeName.toLowerCase();
      if (-1 !== t.inArray(o, i))
        return -1 !== t.inArray(o, r)
          ? Boolean(e.nodeValue.match(p) || e.nodeValue.match(l))
          : !0;
      for (
        var n = t(i).filter(function (t, e) {
            return e instanceof RegExp;
          }),
          s = 0,
          a = n.length;
        a > s;
        s++
      )
        if (o.match(n[s])) return !0;
      return !1;
    }
    function i(i, o, n) {
      if (0 === i.length) return i;
      if (n && "function" == typeof n) return n(i);
      if (
        !document.implementation ||
        !document.implementation.createHTMLDocument
      )
        return i;
      var r = document.implementation.createHTMLDocument("sanitization");
      r.body.innerHTML = i;
      for (
        var s = t.map(o, function (t, e) {
            return e;
          }),
          a = t(r.body).find("*"),
          p = 0,
          l = a.length;
        l > p;
        p++
      ) {
        var h = a[p],
          f = h.nodeName.toLowerCase();
        if (-1 !== t.inArray(f, s))
          for (
            var c = t.map(h.attributes, function (t) {
                return t;
              }),
              u = [].concat(o["*"] || [], o[f] || []),
              d = 0,
              v = c.length;
            v > d;
            d++
          )
            e(c[d], u) || h.removeAttribute(c[d].nodeName);
        else h.parentNode.removeChild(h);
      }
      return r.body.innerHTML;
    }
    function o(e) {
      return this.each(function () {
        var i = t(this),
          o = i.data("bs.tooltip"),
          n = "object" == typeof e && e;
        (!o && /destroy|hide/.test(e)) ||
          (o || i.data("bs.tooltip", (o = new h(this, n))),
          "string" == typeof e && o[e]());
      });
    }
    var n = ["sanitize", "whiteList", "sanitizeFn"],
      r = [
        "background",
        "cite",
        "href",
        "itemtype",
        "longdesc",
        "poster",
        "src",
        "xlink:href",
      ],
      s = /^aria-[\w-]*$/i,
      a = {
        "*": ["class", "dir", "id", "lang", "role", s],
        a: ["target", "href", "title", "rel"],
        area: [],
        b: [],
        br: [],
        col: [],
        code: [],
        div: [],
        em: [],
        hr: [],
        h1: [],
        h2: [],
        h3: [],
        h4: [],
        h5: [],
        h6: [],
        i: [],
        img: ["src", "alt", "title", "width", "height"],
        li: [],
        ol: [],
        p: [],
        pre: [],
        s: [],
        small: [],
        span: [],
        sub: [],
        sup: [],
        strong: [],
        u: [],
        ul: [],
      },
      p = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi,
      l =
        /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i,
      h = function (t, e) {
        (this.type = null),
          (this.options = null),
          (this.enabled = null),
          (this.timeout = null),
          (this.hoverState = null),
          (this.$element = null),
          (this.inState = null),
          this.init("tooltip", t, e);
      };
    (h.VERSION = "3.4.1"),
      (h.TRANSITION_DURATION = 150),
      (h.DEFAULTS = {
        animation: !0,
        placement: "top",
        selector: !1,
        template:
          '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        trigger: "hover focus",
        title: "",
        delay: 0,
        html: !1,
        container: !1,
        viewport: { selector: "body", padding: 0 },
        sanitize: !0,
        sanitizeFn: null,
        whiteList: a,
      }),
      (h.prototype.init = function (e, i, o) {
        if (
          ((this.enabled = !0),
          (this.type = e),
          (this.$element = t(i)),
          (this.options = this.getOptions(o)),
          (this.$viewport =
            this.options.viewport &&
            t(document).find(
              t.isFunction(this.options.viewport)
                ? this.options.viewport.call(this, this.$element)
                : this.options.viewport.selector || this.options.viewport
            )),
          (this.inState = { click: !1, hover: !1, focus: !1 }),
          this.$element[0] instanceof document.constructor &&
            !this.options.selector)
        )
          throw new Error(
            "`selector` option must be specified when initializing " +
              this.type +
              " on the window.document object!"
          );
        for (var n = this.options.trigger.split(" "), r = n.length; r--; ) {
          var s = n[r];
          if ("click" == s)
            this.$element.on(
              "click." + this.type,
              this.options.selector,
              t.proxy(this.toggle, this)
            );
          else if ("manual" != s) {
            var a = "hover" == s ? "mouseenter" : "focusin",
              p = "hover" == s ? "mouseleave" : "focusout";
            this.$element.on(
              a + "." + this.type,
              this.options.selector,
              t.proxy(this.enter, this)
            ),
              this.$element.on(
                p + "." + this.type,
                this.options.selector,
                t.proxy(this.leave, this)
              );
          }
        }
        this.options.selector
          ? (this._options = t.extend({}, this.options, {
              trigger: "manual",
              selector: "",
            }))
          : this.fixTitle();
      }),
      (h.prototype.getDefaults = function () {
        return h.DEFAULTS;
      }),
      (h.prototype.getOptions = function (e) {
        var o = this.$element.data();
        for (var r in o)
          o.hasOwnProperty(r) && -1 !== t.inArray(r, n) && delete o[r];
        return (
          (e = t.extend({}, this.getDefaults(), o, e)),
          e.delay &&
            "number" == typeof e.delay &&
            (e.delay = { show: e.delay, hide: e.delay }),
          e.sanitize && (e.template = i(e.template, e.whiteList, e.sanitizeFn)),
          e
        );
      }),
      (h.prototype.getDelegateOptions = function () {
        var e = {},
          i = this.getDefaults();
        return (
          this._options &&
            t.each(this._options, function (t, o) {
              i[t] != o && (e[t] = o);
            }),
          e
        );
      }),
      (h.prototype.enter = function (e) {
        var i =
          e instanceof this.constructor
            ? e
            : t(e.currentTarget).data("bs." + this.type);
        return (
          i ||
            ((i = new this.constructor(
              e.currentTarget,
              this.getDelegateOptions()
            )),
            t(e.currentTarget).data("bs." + this.type, i)),
          e instanceof t.Event &&
            (i.inState["focusin" == e.type ? "focus" : "hover"] = !0),
          i.tip().hasClass("in") || "in" == i.hoverState
            ? void (i.hoverState = "in")
            : (clearTimeout(i.timeout),
              (i.hoverState = "in"),
              i.options.delay && i.options.delay.show
                ? void (i.timeout = setTimeout(function () {
                    "in" == i.hoverState && i.show();
                  }, i.options.delay.show))
                : i.show())
        );
      }),
      (h.prototype.isInStateTrue = function () {
        for (var t in this.inState) if (this.inState[t]) return !0;
        return !1;
      }),
      (h.prototype.leave = function (e) {
        var i =
          e instanceof this.constructor
            ? e
            : t(e.currentTarget).data("bs." + this.type);
        return (
          i ||
            ((i = new this.constructor(
              e.currentTarget,
              this.getDelegateOptions()
            )),
            t(e.currentTarget).data("bs." + this.type, i)),
          e instanceof t.Event &&
            (i.inState["focusout" == e.type ? "focus" : "hover"] = !1),
          i.isInStateTrue()
            ? void 0
            : (clearTimeout(i.timeout),
              (i.hoverState = "out"),
              i.options.delay && i.options.delay.hide
                ? void (i.timeout = setTimeout(function () {
                    "out" == i.hoverState && i.hide();
                  }, i.options.delay.hide))
                : i.hide())
        );
      }),
      (h.prototype.show = function () {
        var e = t.Event("show.bs." + this.type);
        if (this.hasContent() && this.enabled) {
          this.$element.trigger(e);
          var i = t.contains(
            this.$element[0].ownerDocument.documentElement,
            this.$element[0]
          );
          if (e.isDefaultPrevented() || !i) return;
          var o = this,
            n = this.tip(),
            r = this.getUID(this.type);
          this.setContent(),
            n.attr("id", r),
            this.$element.attr("aria-describedby", r),
            this.options.animation && n.addClass("fade");
          var s =
              "function" == typeof this.options.placement
                ? this.options.placement.call(this, n[0], this.$element[0])
                : this.options.placement,
            a = /\s?auto?\s?/i,
            p = a.test(s);
          p && (s = s.replace(a, "") || "top"),
            n
              .detach()
              .css({ top: 0, left: 0, display: "block" })
              .addClass(s)
              .data("bs." + this.type, this),
            this.options.container
              ? n.appendTo(t(document).find(this.options.container))
              : n.insertAfter(this.$element),
            this.$element.trigger("inserted.bs." + this.type);
          var l = this.getPosition(),
            f = n[0].offsetWidth,
            c = n[0].offsetHeight;
          if (p) {
            var u = s,
              d = this.getPosition(this.$viewport);
            (s =
              "bottom" == s && l.bottom + c > d.bottom
                ? "top"
                : "top" == s && l.top - c < d.top
                ? "bottom"
                : "right" == s && l.right + f > d.width
                ? "left"
                : "left" == s && l.left - f < d.left
                ? "right"
                : s),
              n.removeClass(u).addClass(s);
          }
          var v = this.getCalculatedOffset(s, l, f, c);
          this.applyPlacement(v, s);
          var m = function () {
            var t = o.hoverState;
            o.$element.trigger("shown.bs." + o.type),
              (o.hoverState = null),
              "out" == t && o.leave(o);
          };
          t.support.transition && this.$tip.hasClass("fade")
            ? n
                .one("bsTransitionEnd", m)
                .emulateTransitionEnd(h.TRANSITION_DURATION)
            : m();
        }
      }),
      (h.prototype.applyPlacement = function (e, i) {
        var o = this.tip(),
          n = o[0].offsetWidth,
          r = o[0].offsetHeight,
          s = parseInt(o.css("margin-top"), 10),
          a = parseInt(o.css("margin-left"), 10);
        isNaN(s) && (s = 0),
          isNaN(a) && (a = 0),
          (e.top += s),
          (e.left += a),
          t.offset.setOffset(
            o[0],
            t.extend(
              {
                using: function (t) {
                  o.css({ top: Math.round(t.top), left: Math.round(t.left) });
                },
              },
              e
            ),
            0
          ),
          o.addClass("in");
        var p = o[0].offsetWidth,
          l = o[0].offsetHeight;
        "top" == i && l != r && (e.top = e.top + r - l);
        var h = this.getViewportAdjustedDelta(i, e, p, l);
        h.left ? (e.left += h.left) : (e.top += h.top);
        var f = /top|bottom/.test(i),
          c = f ? 2 * h.left - n + p : 2 * h.top - r + l,
          u = f ? "offsetWidth" : "offsetHeight";
        o.offset(e), this.replaceArrow(c, o[0][u], f);
      }),
      (h.prototype.replaceArrow = function (t, e, i) {
        this.arrow()
          .css(i ? "left" : "top", 50 * (1 - t / e) + "%")
          .css(i ? "top" : "left", "");
      }),
      (h.prototype.setContent = function () {
        var t = this.tip(),
          e = this.getTitle();
        this.options.html
          ? (this.options.sanitize &&
              (e = i(e, this.options.whiteList, this.options.sanitizeFn)),
            t.find(".tooltip-inner").html(e))
          : t.find(".tooltip-inner").text(e),
          t.removeClass("fade in top bottom left right");
      }),
      (h.prototype.hide = function (e) {
        function i() {
          "in" != o.hoverState && n.detach(),
            o.$element &&
              o.$element
                .removeAttr("aria-describedby")
                .trigger("hidden.bs." + o.type),
            e && e();
        }
        var o = this,
          n = t(this.$tip),
          r = t.Event("hide.bs." + this.type);
        return (
          this.$element.trigger(r),
          r.isDefaultPrevented()
            ? void 0
            : (n.removeClass("in"),
              t.support.transition && n.hasClass("fade")
                ? n
                    .one("bsTransitionEnd", i)
                    .emulateTransitionEnd(h.TRANSITION_DURATION)
                : i(),
              (this.hoverState = null),
              this)
        );
      }),
      (h.prototype.fixTitle = function () {
        var t = this.$element;
        (t.attr("title") || "string" != typeof t.attr("data-original-title")) &&
          t
            .attr("data-original-title", t.attr("title") || "")
            .attr("title", "");
      }),
      (h.prototype.hasContent = function () {
        return this.getTitle();
      }),
      (h.prototype.getPosition = function (e) {
        e = e || this.$element;
        var i = e[0],
          o = "BODY" == i.tagName,
          n = i.getBoundingClientRect();
        null == n.width &&
          (n = t.extend({}, n, {
            width: n.right - n.left,
            height: n.bottom - n.top,
          }));
        var r = window.SVGElement && i instanceof window.SVGElement,
          s = o ? { top: 0, left: 0 } : r ? null : e.offset(),
          a = {
            scroll: o
              ? document.documentElement.scrollTop || document.body.scrollTop
              : e.scrollTop(),
          },
          p = o
            ? { width: t(window).width(), height: t(window).height() }
            : null;
        return t.extend({}, n, a, p, s);
      }),
      (h.prototype.getCalculatedOffset = function (t, e, i, o) {
        return "bottom" == t
          ? { top: e.top + e.height, left: e.left + e.width / 2 - i / 2 }
          : "top" == t
          ? { top: e.top - o, left: e.left + e.width / 2 - i / 2 }
          : "left" == t
          ? { top: e.top + e.height / 2 - o / 2, left: e.left - i }
          : { top: e.top + e.height / 2 - o / 2, left: e.left + e.width };
      }),
      (h.prototype.getViewportAdjustedDelta = function (t, e, i, o) {
        var n = { top: 0, left: 0 };
        if (!this.$viewport) return n;
        var r = (this.options.viewport && this.options.viewport.padding) || 0,
          s = this.getPosition(this.$viewport);
        if (/right|left/.test(t)) {
          var a = e.top - r - s.scroll,
            p = e.top + r - s.scroll + o;
          a < s.top
            ? (n.top = s.top - a)
            : p > s.top + s.height && (n.top = s.top + s.height - p);
        } else {
          var l = e.left - r,
            h = e.left + r + i;
          l < s.left
            ? (n.left = s.left - l)
            : h > s.right && (n.left = s.left + s.width - h);
        }
        return n;
      }),
      (h.prototype.getTitle = function () {
        var t,
          e = this.$element,
          i = this.options;
        return (t =
          e.attr("data-original-title") ||
          ("function" == typeof i.title ? i.title.call(e[0]) : i.title));
      }),
      (h.prototype.getUID = function (t) {
        do t += ~~(1e6 * Math.random());
        while (document.getElementById(t));
        return t;
      }),
      (h.prototype.tip = function () {
        if (
          !this.$tip &&
          ((this.$tip = t(this.options.template)), 1 != this.$tip.length)
        )
          throw new Error(
            this.type +
              " `template` option must consist of exactly 1 top-level element!"
          );
        return this.$tip;
      }),
      (h.prototype.arrow = function () {
        return (this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow"));
      }),
      (h.prototype.enable = function () {
        this.enabled = !0;
      }),
      (h.prototype.disable = function () {
        this.enabled = !1;
      }),
      (h.prototype.toggleEnabled = function () {
        this.enabled = !this.enabled;
      }),
      (h.prototype.toggle = function (e) {
        var i = this;
        e &&
          ((i = t(e.currentTarget).data("bs." + this.type)),
          i ||
            ((i = new this.constructor(
              e.currentTarget,
              this.getDelegateOptions()
            )),
            t(e.currentTarget).data("bs." + this.type, i))),
          e
            ? ((i.inState.click = !i.inState.click),
              i.isInStateTrue() ? i.enter(i) : i.leave(i))
            : i.tip().hasClass("in")
            ? i.leave(i)
            : i.enter(i);
      }),
      (h.prototype.destroy = function () {
        var t = this;
        clearTimeout(this.timeout),
          this.hide(function () {
            t.$element.off("." + t.type).removeData("bs." + t.type),
              t.$tip && t.$tip.detach(),
              (t.$tip = null),
              (t.$arrow = null),
              (t.$viewport = null),
              (t.$element = null);
          });
      }),
      (h.prototype.sanitizeHtml = function (t) {
        return i(t, this.options.whiteList, this.options.sanitizeFn);
      });
    var f = t.fn.tooltip;
    (t.fn.tooltip = o),
      (t.fn.tooltip.Constructor = h),
      (t.fn.tooltip.noConflict = function () {
        return (t.fn.tooltip = f), this;
      });
  })(jQuery),
  +(function (t) {
    "use strict";
    function e(e) {
      return this.each(function () {
        var o = t(this),
          n = o.data("bs.popover"),
          r = "object" == typeof e && e;
        (!n && /destroy|hide/.test(e)) ||
          (n || o.data("bs.popover", (n = new i(this, r))),
          "string" == typeof e && n[e]());
      });
    }
    var i = function (t, e) {
      this.init("popover", t, e);
    };
    if (!t.fn.tooltip) throw new Error("Popover requires tooltip.js");
    (i.VERSION = "3.4.1"),
      (i.DEFAULTS = t.extend({}, t.fn.tooltip.Constructor.DEFAULTS, {
        placement: "right",
        trigger: "click",
        content: "",
        template:
          '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>',
      })),
      (i.prototype = t.extend({}, t.fn.tooltip.Constructor.prototype)),
      (i.prototype.constructor = i),
      (i.prototype.getDefaults = function () {
        return i.DEFAULTS;
      }),
      (i.prototype.setContent = function () {
        var t = this.tip(),
          e = this.getTitle(),
          i = this.getContent();
        if (this.options.html) {
          var o = typeof i;
          this.options.sanitize &&
            ((e = this.sanitizeHtml(e)),
            "string" === o && (i = this.sanitizeHtml(i))),
            t.find(".popover-title").html(e),
            t
              .find(".popover-content")
              .children()
              .detach()
              .end()
              ["string" === o ? "html" : "append"](i);
        } else
          t.find(".popover-title").text(e),
            t.find(".popover-content").children().detach().end().text(i);
        t.removeClass("fade top bottom left right in"),
          t.find(".popover-title").html() || t.find(".popover-title").hide();
      }),
      (i.prototype.hasContent = function () {
        return this.getTitle() || this.getContent();
      }),
      (i.prototype.getContent = function () {
        var t = this.$element,
          e = this.options;
        return (
          t.attr("data-content") ||
          ("function" == typeof e.content ? e.content.call(t[0]) : e.content)
        );
      }),
      (i.prototype.arrow = function () {
        return (this.$arrow = this.$arrow || this.tip().find(".arrow"));
      });
    var o = t.fn.popover;
    (t.fn.popover = e),
      (t.fn.popover.Constructor = i),
      (t.fn.popover.noConflict = function () {
        return (t.fn.popover = o), this;
      });
  })(jQuery);
$(function () {
  var sposition = $(".site-footer").offset().top - $(".site-footer").height();
  $(window).scroll(function () {
    var sticky = $(".scac-bar"),
      scroll = $(window).scrollTop();

    if (scroll >= 102 && scroll <= sposition) sticky.addClass("scac-bar-fixed");
    else sticky.removeClass("scac-bar-fixed");
  });

  setTimeout(function () {
    var sposition = $(".site-footer").offset().top - $(".site-footer").height();
    $(window).scroll(function () {
      var sticky = $(".add-to-cart-bar"),
        scroll = $(window).scrollTop();

      if (scroll >= 102 && scroll <= sposition)
        sticky.addClass("scac-bar-fixed");
      else sticky.removeClass("scac-bar-fixed");
    });
  }, 1500);

  $("#sticky_add_to_cart").click(function (event) {
    event.preventDefault();
  });

  if ($(".style-with-it").length) {
    var handle = $(".style-with-it").attr("data-handle");
    var sectionid = $(".style-with-it").attr("sectionid");
    $(".style-with-it-main").css("opacity", "0");
    $.ajax({
      type: "GET",
      url: "/products/" + handle + "?view=more-like-this-popup",
      cache: false,
      dataType: "html",
      success: function (data) {
        $(".style-with-it-main").html(data);

        setTimeout(function () {
          $(".style-with-it-main .mlt-popip-products").slick({
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 3,
            dots: false,
            arrows: true,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                  infinite: true,
                  dots: true,
                },
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                },
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                },
              },
            ],
          });
          $(".style-with-it-main").css("opacity", "1");
          if (
            $(".style-with-it-main product-recommendations").hasClass("hide")
          ) {
            $(".style-with-it").hide();
          }
        }, 2000);
      },
    });
  }

  setTimeout(function () {
    /*
          $('product-recommendations .grid').slick({
              dots: true,
              infinite: true,
              speed: 300,
              slidesToShow: 4,
              slidesToScroll: 4,
              dots: false,
              arrows:true,
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                }
                
              ]
            });
    */
  }, 1500);
});
$(document).ready(function () {
  $(".collection-vertical").show();
  $(".collection-vertical .collapsible-trigger.is-open").click();
  $(
    ".collapsible-trigger[data-collapsible-id='filter-waist-size']"
  ).removeClass("is-open");
  $(
    ".collapsible-content[data-collapsible-id='filter-waist-size']"
  ).removeClass("is-open");

  $('[data-toggle="tooltip"]').tooltip();
  $(".collection-product-slider .grid").slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: false,
    arrows: true,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  });

  $("body").on("click", ".our-partners-tabs a", function () {
    var type = $(this).attr("data-type");
    $(".our-partners-tabs a").removeClass("active");
    $(this).addClass("active");
    if (type != "all") {
      $(".our-partners-grid").hide();
      $(".our-partners-grid." + type).show();
    } else {
      $(".our-partners-grid").show();
    }
  });

  $("body").on("click", ".mltpopup__close", function (e) {
    e.preventDefault();
    $(".mltpopup__overlay.leadform").removeClass("active");
  });

  $("body").click(function (e) {
    if (!$(e.target).closest(".collection-sidebar__group").length) {
      $(".collection-vertical .collapsible-trigger.is-open").click();
    }
  });

  $(".pg-add-to-cart").click(function (e) {
    var id = $(this).attr("data-id");
    var q = 1;
    var ajax = {
      type: "POST",
      url: "/cart/add.js",
      data: "quantity=" + q + "&id=" + id,
      dataType: "json",
      success: function (n) {
        document.dispatchEvent(new CustomEvent("cart:build"));
        document.dispatchEvent(new CustomEvent("cart:open"));
      },
      error: function (error) {
        const obj = JSON.parse(error.responseText);
        alert(obj.description);
      },
    };
    jQuery.ajax(ajax);
  });

  $("body").on('keyup','.filter-search',function () {
    var searchtext = $(this).val().toLowerCase();
    if (searchtext.length >= 1) {
      $(this)
        .parents(".collapsible-content__inner")
        .find("li.tag")
        .each(function () {
          var $this = $(this);
          var $text = $this.find(".tag__text").text().toLowerCase();
          var indexcount = $text.indexOf(searchtext);
          if (indexcount > -1) {
            $this.show();
          } else {
            $this.hide();
          }
        });
    }
    if (searchtext.length == 0) {
      $(this).parents(".collapsible-content__inner").find("li.tag").show();
    }
  });
});

if (document.getElementsByClassName("product-accordion").length) {
  var acc = document.getElementsByClassName("accordion");
  var ao;

  for (ao = 0; ao < acc.length; ao++) {
    acc[ao].addEventListener("click", function () {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
        panel.style.minHeight = null;
      } else {
        panel.style.maxHeight =
          parseInt(panel.scrollHeight) + parseInt(20) + "px";
        panel.style.minHeight =
          parseInt(panel.scrollHeight) + parseInt(20) + "px";
      }
    });
  }
}

if (document.getElementsByClassName("kit-accordion").length) {
  var acc = document.getElementsByClassName("accordion");
  var ao;

  for (ao = 0; ao < acc.length; ao++) {
    acc[ao].addEventListener("click", function () {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
        panel.style.minHeight = null;
      } else {
        panel.style.maxHeight =
          parseInt(panel.scrollHeight) + parseInt(20) + "px";
        panel.style.minHeight =
          parseInt(panel.scrollHeight) + parseInt(20) + "px";
      }
    });
  }
}

window.ac = window.ac || {};
ac.chatLink = document.querySelector("a[href='#chat']");

if (ac.chatLink) {
  ac.chatLink.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();

    chat = document.getElementById("ShopifyChat");
    iframeId = chat ? "ShopifyChat" : "dummy-chat-button-iframe";
    document
      .getElementById(`${iframeId}`)
      .shadowRoot.querySelector("button.chat-toggle")
      .click();
  });
}
